<div *ngIf="isUpdateAvailable" class="update-overlay">
	<div class="update-notification">
		<h2>🚀 New App Update!</h2>
		<p>Please wait 3 seconds while we load the latest version to ensure stability.</p>
		<p>Your session is refreshing automatically...</p>
		<div class="spinner"></div>
	</div>
</div>
<ngx-loading-bar [color]="'#5a31f4'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar>
<app-loader></app-loader>
<app-tap-to-top></app-tap-to-top>
<router-outlet></router-outlet>
